import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FAQs() {
    // How much does indi cost ?
    //         As a BRG patient, you have free access to indi for two weeks – no credit card or billing information required.If you enjoy your first two weeks, you can choose between our annual plan($119 / yr) or our monthly plan($14.99 / mo).
    // What is indi ?
    //         Indi is an online and app - based wellness & exercise platform to get the world moving.Our focus is to provide safe, effective, and low - impact workouts that improve the health, wellness, and independence of our members.
    // What device can I use indi on ?
    //         Indi offers a variety of ways to access your content.You can use any laptop, tablet, or phone browser.The indi app can also be found in the Apple App Store or Google Play Store for easy access from your phone or tablet.
    // Do I need equipment ?
    //         Though some pieces of equipment are nice to have, you can experience indi without any extra purchases.
    // Is indi right for me ?
    //         Indi isn’t like other exercise platforms.Our Physical Therapist - designed programs are tailored for everyday people.Unlike other programs, we offer safe and low - impact workouts that won’t leave you exhausted or injured.
    // What are indi workouts like ?
    //         Indi has a variety of workouts that focus on mobility, strength, body aches and pains, and more.Whether you’re new to fitness, or you’re looking to switch up your current routine, indi’s low - impact workouts can fit into your life.


    const faqs = [
        {
            question: "How much does indi cost?",
            answer: "As a BRG patient, they have free access to indi for two weeks – no credit card or billing information required. If they enjoy their first two weeks, they can choose between our annual plan ($119 / yr) or our monthly plan ($14.99 / mo)."
        },
        {
            question: "What is indi?",
            answer: "Indi is an online and app-based wellness & exercise platform to get the world moving. Our focus is to provide safe, effective, and low-impact workouts that improve the health, wellness, and independence of our members."
        },
        {
            question: "What device can indi be used on?",
            answer: "Indi offers a variety of ways to access content. Users can use any laptop, tablet, or phone browser. The indi app can also be found in the Apple App Store or Google Play Store for easy access from phones or tablets."
        },
        {
            question: "Is equipment needed?",
            answer: "Though some pieces of equipment are nice to have, users can experience indi without any extra purchases."
        },
        {
            question: "Who is indi right for?",
            answer: "Indi isn’t like other exercise platforms. Our Physical Therapist-designed programs are tailored for everyday people. Unlike other programs, we offer safe and low-impact workouts that won’t leave you exhausted or injured."
        },
        {
            question: "What are indi workouts like?",
            answer: "Indi has a variety of workouts that focus on mobility, strength, body aches and pains, and more. Whether someone is new to fitness, or looking to switch up their current routine, indi’s lowimpact workouts can fit into their life."
        },
    ];

    return (
        <div id="faq" className="fpc">
            <div className="fpc-header">
                <h4>Frequently Asked Questions</h4>
                <span>Review below for answers to patient questions. If you need further assistance, please email <a>oszpylman@buffalorehab.com</a>.</span>
            </div>

            <div className="fpc-content">
                <div id="faq-list">
                    {
                        faqs.map((faq, index) => (
                            <div className="faq-item" key={index}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        className="faq-as"
                                    >
                                        <h5>{faq.question}</h5>
                                    </AccordionSummary>
                                    <AccordionDetails className="faq-ad">
                                        <div >
                                            <span>{faq.answer}</span>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default FAQs;